// Script pour autoplay les vidéos au hover sur les product cards
(function() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoHover);
  } else {
    initVideoHover();
  }

  function initVideoHover() {
    // Trouver toutes les product cards avec des vidéos (product-card-container)
    const productCards = document.querySelectorAll('.product-card-container');
    
    productCards.forEach(function(card) {
      const video = card.querySelector('[data-video-hover]');
      
      if (video) {
        // Au hover: play la vidéo
        card.addEventListener('mouseenter', function() {
          video.play().catch(function(error) {
            console.log('Video autoplay prevented:', error);
          });
        });
        
        // Hover terminé: pause et reset la vidéo
        card.addEventListener('mouseleave', function() {
          video.pause();
          video.currentTime = 0;
        });
      }
    });

    // Trouver toutes les grid-product cards avec des vidéos (product-recommendations)
    const gridProducts = document.querySelectorAll('.grid-product');
    
    gridProducts.forEach(function(card) {
      const video = card.querySelector('[data-video-hover]');
      
      if (video) {
        // Au hover: play la vidéo
        card.addEventListener('mouseenter', function() {
          video.play().catch(function(error) {
            console.log('Video autoplay prevented:', error);
          });
        });
        
        // Hover terminé: pause et reset la vidéo
        card.addEventListener('mouseleave', function() {
          video.pause();
          video.currentTime = 0;
        });
      }
    });
  }
})();